import { AAGUID } from '@interticket/core';
import { IAdminPartner } from '@core/interfaces/iam/admin-partner.interface';

export class AdminPartner implements IAdminPartner {

  readonly name: string;
  readonly partnerId: AAGUID;
  readonly current: boolean;

  constructor(iAdminPartner: IAdminPartner) {
    this.name = iAdminPartner.name;
    this.partnerId = iAdminPartner.partnerId;
    this.current = iAdminPartner.current;
  }

}
